import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';

import { ProgressService } from 'src/app/services/progress.service';
import { EditCompetitorService } from '../edit-competitor/edit-competitor.service';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { RaceProgress, RaceRefreshObject, InfoLapModalData, ClassProgress, Lap, Mark, User } from 'src/app/models';
import { RaceProgressRegistration } from 'src/app/models/race_progress_registration';
import { SettingsService } from 'src/app/services/settings.service';
import { SelectedDisplayType } from 'src/app/models/selected-display-type';
import { AuthService } from 'src/app/services/auth.service';
import { UserDomainService } from 'src/app/domains/user.service';
@Component({
  selector: 'app-progress-list-v2',
  templateUrl: './progress-list-v2.component.html',
  styleUrls: ['./progress-list-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressListV2Component implements OnInit, OnDestroy, AfterViewChecked {
  @Input() selectedRace!: Race;
  @Input() raceClasses: RaceClass[] = [];
  @Input() selectedLang!: string;
  _selectedClass!: RaceClass;
  raceProgress!: RaceProgress;
  loading: boolean = false;
  scrollToNumberValue: number | undefined = undefined;
  @Input() set selectedClass(value: RaceClass) {
    this._selectedClass = value;
    // this.update();
  }
  get selectedClass(): RaceClass {
    return this._selectedClass;
  }

  @Output() refreshEvent: EventEmitter<RaceRefreshObject> = new EventEmitter();
  @Output() openInfoEvent: EventEmitter<string> = new EventEmitter();
  @Output() openCompetitorRaceDataEvent: EventEmitter<string> = new EventEmitter();
  @ViewChild('turboTable') turboTable!: Table;
  @ViewChildren('competitorrow') rowElement!: QueryList<ElementRef>;
  @ViewChild('tabsList', { read: ElementRef }) tabsList!: ElementRef;
  @Output() goToNewVersion = new EventEmitter<void>();

  // scrollableCols: any[];
  // frozenCols: any[];
  getDNF: string[];
  lapHover: Lap | null;
  checkHeight = false;
  time_state = 1;
  infoLapModal = false;
  infoLapModalData!: InfoLapModalData;
  editLapModal = false;
  infoClassModal = false;
  infoClassModalData!: ClassProgress;

  tabs = [];
  selectedTab;
  selectedDisplay: SelectedDisplayType = 'short';

  tableShowDetails: boolean = false;
  isMobile: boolean = window.innerWidth < 800;
  filter: string | null = null;

  modeEdit: boolean = false;

  timeFormat = 'HH:mm:ss';

  // Зал славы
  showCompetitorHofModal: boolean = false;
  selectedHofUser: User | null = null;

  @ViewChild('topNavigation') topNavigation!: ElementRef;
  @ViewChild('raceHead') raceHead!: ElementRef;

  private updateInitiator: Subject<RaceClass['clUid']> = new Subject();
  private subscriptionUpdate: Subscription;
  private searchCompetitorByNumber: Subject<number> = new Subject();
  private subscribeSearchCompetitorByNumber: Subscription;

  constructor(
    public progressService: ProgressService,
    public authService: AuthService,
    public appSettings: SettingsService,
    private ref: ChangeDetectorRef,
    private editCompetitorService: EditCompetitorService,
    public messageService: MessageService,
    private userDomainService: UserDomainService
  ) {
    this.subscriptionUpdate = this.subscribeToUpdate();
    this.subscribeSearchCompetitorByNumber = this.subscribeToSearchCompetitorByNumber();
    this.progressService.refreshTableData.subscribe((classUid) => {
      this.update(classUid);
    });
    this.lapHover = null;
    // this.frozenCols = [
    //   { field: 'position', header_index: 'pos', width: '50px' },
    //   { field: 'name', header_index: 'information', width: '150px' },
    //   { field: 'timeall', header_index: 'startFinish', width: '100px' },
    // ];

    // this.scrollableCols = [];

    this.getDNF = ['', 'дисквалификация', 'вышло время', 'поломка', 'травма', 'не финишировал'];
  }

  ngOnDestroy(): void {
    this.updateInitiator.unsubscribe();
    this.subscriptionUpdate.unsubscribe
    this.searchCompetitorByNumber.unsubscribe
    this.subscribeSearchCompetitorByNumber.unsubscribe();
    this.progressService.refreshTableData.unsubscribe();
  }

  filterCompetitorsList(e: HTMLInputElement) {
    this.filter = e.value;
    this.searchCompetitorByNumber.next(Number(this.filter));
  }

  clearFilter(e: HTMLInputElement) {
    e.value = '';
    this.filter = null;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const rect = this.raceHead.nativeElement.getBoundingClientRect();
    if (rect.bottom < 0) {
      this.topNavigation.nativeElement.style.display = 'block';
    } else {
      this.topNavigation.nativeElement.style.display = 'none';
    }
  }

  async ngOnInit() {
    this.checkClassesScroll();
    if (this.selectedRace && this.selectedRace.showMillsInResults) this.timeFormat = 'HH:mm:ss.SSS';
  }

  public timeStateChange(e: number) {
    this.time_state = e;
    this.ref.markForCheck();
  }

  clickInfo(cUid: string) {
    this.openInfoEvent.emit(cUid);
  }

  showHof(cUid: string) {
    // Находим пользователя по cUid
    const user = this.findUserByCuid(cUid);
    if (user) {
      this.selectedHofUser = user;
      this.showCompetitorHofModal = true;
      this.ref.detectChanges();
    }
  }

  private findUserByCuid(cUid: string): User | null {
    if (!this.raceProgress) return null;
    for (const raceClass of this.raceProgress.classes) {
      for (const competitor of raceClass.registrations) {
        if (competitor.registration.user.cUid === cUid) {
          return competitor.registration.user;
        }
      }
    }
    return null;
  }

  clickRaceData(cUid: string) {
    if (this.modeEdit || !this.raceProgress) return;
    let penaltyText = '';
    this.raceProgress.classes.forEach((raceClass) => {
      raceClass.registrations.forEach((competitor) => {
        if (competitor.registration.user.cUid === cUid) {
          let lapNum = 0;
          let lapsPenalty = 0;
          competitor.laps.forEach((lap) => {
            lapNum++;
            if (lap.penalty.length) {
              penaltyText += `Lap: ${lapNum}</br>`;
              lap.penalty.forEach((penalty) => {
                if (penalty.time) {
                  let lapPenalty = penalty.time.getTime();
                  lapsPenalty += lapPenalty;
                  penaltyText += `  lap penalty: ${lapPenalty} - ${penalty.text}</br>`;
                }
              });
            }
          });
          let manualPenalty = Math.floor(competitor.penalty / 1000) - lapsPenalty;
          if (manualPenalty != 0) penaltyText += `</br></br>${manualPenalty} - ${competitor.penaltyComment}`;
        }
      });
    });
    this.messageService.clear();
    if (penaltyText.length) {
      this.openCompetitorRaceDataEvent.emit(penaltyText);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: this.appSettings.translate[this.appSettings.selectedLang]['nopenalty'],
      });
    }
  }

  private subscribeToSearchCompetitorByNumber() {
    return this.searchCompetitorByNumber
      .pipe(
        debounceTime(1000),
        switchMap((number) => {
          return this.progressService.getClassByNumberCompetitor(this.selectedRace.rUid, number);
        })
      )
      .subscribe(({ clUid, cNumber }) => {
        if (clUid) {
          this.refresh(clUid, Number(cNumber));
        } else {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: this.appSettings.translate[this.appSettings.selectedLang]['notFoundCompetitorByNumber'],
          });
        }
      });
  }

  private subscribeToUpdate() {
    return this.updateInitiator
      .pipe(
        tap(() => {
          this.loading = true;
          if (this.raceProgress) {
            this.raceProgress.classes = [];
          }
          // this.raceProgress = null;
          this.ref.detectChanges();
        }),
        switchMap((classUid) => {
          return this.progressService.getRaceProgress(this.selectedRace.rUid, classUid);
        }),
        tap(() => {
          this.loading = false;
        })
      )
      .subscribe((raceProgress: RaceProgress) => {
        if (!raceProgress) {
          return;
        }
        this.raceProgress = raceProgress;
        // let maxLaps = 1;
        // const lapsNames: string[] = [];
        // this.raceProgress.classes.forEach((classObj) => {
        //   classObj.registrations.forEach((compObj) => {
        //     compObj.tableShowDetails = this.selectedDisplay == 'detail';
        //     // if (!lapsNames.length) {
        //     //   compObj.laps.forEach((lap) => {
        //     //     lapsNames.push(lap.name);
        //     //   });
        //     // }
        //     if (compObj.laps.length > maxLaps) {
        //       maxLaps = compObj.laps.length;
        //     }
        //   });
        // });

        // this.scrollableCols = [];
        // for (let i = 0; i < maxLaps; i++) {
        //   this.scrollableCols.push({
        //     field: `lap`,
        //     lap: i,
        //     // TODO имя круга?
        //     header: i,
        //     //header: lapsNames[i],
        //     type: 1,
        //     width: '110px',
        //   });
        // }
        this.checkHeight = true;
        this.ref.detectChanges();
      });
  }

  async update(classUid: RaceClass['clUid']) {
    this.updateInitiator.next(classUid);
  }

  erase(mark: Mark) {
    mark.time = null;
  }

  trash(mark: Mark) {
    mark.delete = true;
  }

  scrollToNumber(cNumber: number): boolean {
    if (!this.rowElement) {
      return false;
    }
    const el = this.rowElement.find((r) => {
      return parseInt(r.nativeElement.getAttribute('id'), 10) === cNumber;
    });
    if (el) {
      el.nativeElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: 'center',
      });
      return true;
    } else {
      return false;
    }
  }

  async save() {
    const promises: Promise<Object | undefined | void>[] = [];
    this.infoLapModalData.lapNew.marks.forEach((mark) => {
      if (mark.delete) {
        promises.push(this.progressService.deleteMark(mark, this.selectedRace, this.selectedClass, this.infoLapModalData.competitor));
      } else {
        const markOld = this.infoLapModalData.lap.marks.find((item) => item.uid === mark.uid);
        if (markOld) {
          const timeOld = markOld.time ? markOld.time.getTime() : null;
          const timeNew = mark.time ? mark.time.getTime() : null;
          if (timeOld !== timeNew) {
            if (markOld.time) {
              promises.push(this.progressService.deleteMark(markOld, this.selectedRace, this.selectedClass, this.infoLapModalData.competitor));
            }
            promises.push(this.progressService.saveMark(mark.marshal, mark.time ? mark.time.getTime() : null, this.selectedRace.rUid, this.selectedClass.clUid, this.infoLapModalData.competitor.registration.user.cUid));
          }
        } else {
          console.error('not found mark old ;(', mark);
        }
      }
    });
    await Promise.all(promises);
    this.editLapModal = false;
    this.update(this.selectedClass.clUid);
  }

  clickLap(lap: Lap, indexLap, competitor: RaceProgressRegistration) {
    if (this.modeEdit) {
      this.showEditLap(lap, indexLap, competitor);
    } else {
      this.showInfoLap(lap, indexLap, competitor);
    }
  }

  showInfoLap(lap: Lap, indexLap: number, competitor: RaceProgressRegistration) {
    if (lap && lap.penalty.length) {
      this.infoLapModal = true;
      this.infoLapModalData = new InfoLapModalData(lap, indexLap, competitor);
    }
  }

  showEditLap(lap: Lap, indexLap: number, competitor: RaceProgressRegistration) {
    if (lap) {
      this.editLapModal = true;
      this.infoLapModalData = new InfoLapModalData(lap, indexLap, competitor);
    }
  }

  showInfoClass(classProgres: ClassProgress) {
    this.infoClassModalData = classProgres;
    this.infoClassModal = true;
    return false;
  }

  refresh(selectedClassUid: RaceClass['clUid'], cNumber: number | undefined = undefined) {
    this.scrollToNumberValue = cNumber;
    this.refreshEvent.emit({
      selectedRace: this.selectedRace,
      raceClasses: this.raceClasses,
      selectedClassUid,
    });
  }

  ngAfterViewChecked() {
    if (this.checkHeight) {
      if (this.scrollToNumberValue) {
        if (this.scrollToNumber(this.scrollToNumberValue)) {
          this.scrollToNumberValue = undefined;
        }
      }
    }
  }

  hoverLap(lap: Lap) {
    if (this.lapHover !== lap) {
      this.lapHover = lap;
    } else {
      this.lapHover = null;
    }
  }

  width(e): string {
    if (!e.width) {
      e.width = '50px';
    }
    return e.width;
  }

  setDateMark(mark: Mark, event: { value: Date }) {
    if (!event.value) {
      return;
    }
    if (!mark.time) {
      mark.time = new Date(this.selectedRace.date);
    }
    mark.time.setFullYear(event.value.getFullYear());
    mark.time.setMonth(event.value.getMonth());
    mark.time.setDate(event.value.getDate());
  }

  setTimeMark(mark: Mark, event) {
    if (!event.value) {
      return;
    }
    if (!mark.time) {
      mark.time = new Date(this.selectedRace.date);
    }
    mark.time.setHours(event.value.getHours());
    mark.time.setMinutes(event.value.getMinutes());
    mark.time.setSeconds(event.value.getSeconds());
  }

  changeDisplayType(selectedDisplay: SelectedDisplayType) {
    this.selectedDisplay = selectedDisplay;
    const tableShowDetails = selectedDisplay == 'detail';

    if (this.raceProgress) {
      this.raceProgress.classes.forEach((classs) => {
        classs.registrations.forEach((competitor) => {
          competitor.tableShowDetails = tableShowDetails;
        });
      });
    }
  }

  checkClassesScroll() {
    if (!this.tabsList) {
      setTimeout(() => {
        this.checkClassesScroll();
      }, 300);
      return;
    }
    const tabsContainer = this.tabsList.nativeElement;
    const containerWidth = tabsContainer.offsetWidth;
    let contentWidth = 0;

    for (const tab of tabsContainer.children) {
      contentWidth += tab.offsetWidth;
    }

    if (contentWidth > containerWidth) {
      tabsContainer.style.overflowX = 'scroll';
    }
  }

  editCompetitor(competitor: RaceProgressRegistration, e: MouseEvent | null) {
    if (!this.modeEdit) return;
    if (e && (e.target as Element).classList.contains('laps-control')) return;

    const dialogRef = this.editCompetitorService.openEditCompetitor(this.selectedRace, this.selectedClass, competitor);
    dialogRef?.onClose.subscribe((refresh) => {
      if (refresh) {
        this.refreshEvent.emit({
          selectedRace: this.selectedRace,
          raceClasses: this.raceClasses,
          selectedClassUid: this.selectedClass.clUid,
        });
      }
    });
  }
}
